import { IWPImage } from "@/src/types";
import React from "react";

import S from "./MainHero.styled";
import { getImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import AnchorLink from "react-anchor-link-smooth-scroll";

export interface Props {
  title: string;
  text: string;
  mediaType: string;
  backgroundImage: IWPImage;
  backgroundVideo: {
    localFile: {
      publicURL: string;
    };
    mimeType: string;
  };
  ctaButtonText: String;
  ctaText: string;
}

const MainHero: React.FC<Props> = ({
  title,
  text,
  backgroundImage,
  backgroundVideo,
  ctaButtonText,
  ctaText,
}) => {
  // create gatsby-image-data
  const backgroundImageData = backgroundImage?.localFile?.childImageSharp
    ?.gatsbyImageData
    ? getImage(backgroundImage.localFile.childImageSharp.gatsbyImageData)
    : null;

  return (
    <S.Container>
      <div className="relative">
        <S.HeroMainDiv className="flex flex-col justify-center items-center overflow-hidden">
          <div className="absolute z-10 inset-0 bg-gray-700 opacity-60"></div>
          <div
            className="md:block hidden absolute z-0 mx-auto"
            style={{ width: "100%", height: "100%" }}
          >
            {backgroundVideo && (
              <S.VideoContainer>
                <video autoPlay loop muted playsInline>
                  <source
                    src={backgroundVideo.localFile.publicURL}
                    type={backgroundVideo.mimeType}
                  />
                </video>
              </S.VideoContainer>
            )}
          </div>
          <S.MobileBGImage
            className="md:block absolute z-0 mx-auto"
            style={{ width: "100%", height: "100%" }}
          >
            {backgroundImageData && (
              <S.BackgroundImage
                image={backgroundImageData}
                alt={backgroundImage.altText || ""}
              />
            )}
          </S.MobileBGImage>
          <div className="md:mx-auto md:max-w-7xl">
            <div className="relative z-20 lg:w-full md:pb-8 sm:pb-16 md:pb-20 lg:pb-28 xl:pb-32">
              <main className="relative md:mt-10 px-4 sm:mt-12 lg:grid lg:grid-cols-2 lg:grid-flow-col lg:gap-4 lg:items-center sm:block sm:text-center sm:px-6 md:mt-16 lg:mt-20 lg:px-8 xl:mt-28">
                <AnchorLink offset="100" href={"#valkommen"}
                  className={"lg:block hidden absolute -left-24 -bottom-40 z-99 text-base"}
                >
                  <div className="transform -rotate-90 border-t-2 border-metlab-500 w-72 flex justify-end pt-4 text-white uppercase flex items-center">
                    <i className="bx bxs-left-arrow-alt text-metlab-500 mr-2"></i>{" "}
                    {ctaText}
                  </div>
                </AnchorLink>
                {/* Empty Div for Grid */}
                <div></div>
                <div className="px-6 md:px-0 text-center sm:text-center lg:text-right">
                  <h1 className="text-3xl lg:text-5xl tracking-tight font-extrabold text-white sm:text-4xl md:text-6xl">
                    <span className="block xl:inline">{title}</span>
                  </h1>
                  <p className="mt-3 text-white sm:mt-5 sm: sm:mx-auto md:mt-5 lg:mx-0" dangerouslySetInnerHTML={{__html: text}}/>
                  <div className="mt-5 sm:mt-8 sm:flex sm:justify-center lg:justify-end">
                    <div className="">
                      <AnchorLink offset="100" href={"#valkommen"}>
                        <div className="w-full flex items-center justify-center px-8 py-3 font-medium rounded-full text-white bg-metlab-500 transition duration-200 ease-in-out hover:bg-green-600 md:py-4 md: md:px-10">
                          {ctaButtonText}
                        </div>
                      </AnchorLink>
                    </div>
                  </div>
                </div>
              </main>
            </div>
          </div>
        </S.HeroMainDiv>
      </div>
    </S.Container>
  );
};

export default MainHero;
